<!-- @format -->

<template>
	<div class="govuk-grid-row qrs-typography">
		<div id="main" class="govuk-grid-column-two-thirds">
			<div class="list-group list-group-flush">
				<a
					v-bind:href="'/atoz/m/' + q.Alias"
					class="list-group-item list-group-item-action"
					v-for="q in filteredMedicines"
					:key="q.Alias"
					>{{ q.Name }}</a
				>
			</div>
		</div>
	</div>
</template>

<script>
	import MedicinesAtoZ from '../../../App_Data/medicines.json';
	export default {
		name: 'MedicineByLetter',
		props: ['letter'],
		data() {
			return MedicinesAtoZ;
		},
		computed: {
			filteredMedicines() {
				var list = this.MedicinesAtoZ.filter((m) => {
					return m.Letter.Name.match(this.letter.toUpperCase());
				});
				return list[0].Medicines;
			},
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
